import gsap from "gsap";

export default function Hotspots() {
  const hotspots = document.querySelectorAll(".space-image__hotspot");
  const hotspotPreview = document.querySelector(".hotspot-product-preview");
  const hotspotContainer = document.querySelector(".hotspot-product-preview-container");
  const closeButton = hotspotPreview?.querySelector(".hotspot-product-preview__close");
  let isClosing = false;

  let scrollListener;
  let clickListener;

  const closePreview = () => {
    if (hotspotPreview.innerHTML !== "" && !isClosing) {
      isClosing = true;
      gsap.to(hotspotPreview, {
        autoAlpha: 0,
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          hotspotPreview.innerHTML = "";
          isClosing = false;
          window.removeEventListener("scroll", handleListeners);
          window.removeEventListener("click", handleListeners);
        },
      });
      gsap.to(hotspotContainer, { autoAlpha: 0, duration: 0.5, ease: "power2.in" });
    }
  };

  const handleListeners = (e) => {
    if (e.type === "scroll") {
      closePreview();
      return;
    } else if (e.type === "click") {
      if (e.target && !e.target.classList.contains("bg")) return;
      closePreview();
      return;
    }
  };

  hotspots.forEach((hotspot) => {
    hotspot.addEventListener("click", () => {
      const productId = hotspot.getAttribute("data-product-id");
      fetch(`/wp-json/wp/v2/product/${productId}?_embed`)
        .then((response) => response.json())
        .then((product) => {
          const imageUrl = product._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "";
          hotspotPreview.innerHTML = `
                        <div class="hotspot-product-preview__close" aria-label="Close preview">ΚΛΕΙΣΙΜΟ</div>
                        <div class="hotspot-product-preview__content">
                            ${imageUrl ? `<a href="${product.link}"><img src="${imageUrl}" alt="${product.title.rendered}" class="hotspot-product-preview__image"></a>` : ""}
                            <h3>${product.title.rendered}</h3>
                            <a href="${product.link}" class="hotspot-product-preview__button">
                                <span>Δείτε το προϊόν</span>
                                <img class="hotspot-product-preview__icon" src="/wp-content/themes/firos/assets/images/arrow.svg">
                            </a>
                        </div>
                    `;

          // Add close button listener
          const newCloseButton = hotspotPreview.querySelector(".hotspot-product-preview__close");
          newCloseButton.addEventListener("click", closePreview);

          //Animate the preview in
          gsap.fromTo(hotspotPreview, { y: 100, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5, ease: "power2.out" });
          gsap.fromTo(hotspotContainer, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, ease: "power2.out" });

          // Add listeners for scroll and click outside
          window.addEventListener("scroll", handleListeners);
          window.addEventListener("click", handleListeners);
        })
        .catch((error) => console.error("Error fetching product data:", error));
    });
  });

  // Close preview on scroll
}
